import { ReactNode } from "react";

export const InfoBlock: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  return <div className="infoBlock">{children}</div>;
};
